import React from "react"
function SuccessMessage({ success, handleHideMsg}) {
    return (
        <>
          {success && 
            <div className="flex flex-row justify-between px-4 py-4 bg-green-50 text-left sm:px-6 shadow-sm">
              <div className="list-none text-md text-green-500">     
                <span>{success}</span>
              </div>
              <div className="list-none text-md text-green-500">     
                <button onClick={handleHideMsg} >x</button>
              </div>
            </div>
          }
        </>
    )
}
export default React.memo(SuccessMessage);
